export const SUPER_ADMIN = 'super-admin';